import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';

import AwaitingApproval from './AwaitingApproval';
import MissingTicketNumbers from './MissingTicketNumbers';
import LockPayPeriod from './LockPayPeriod';

import SplitLayout from '../../../layouts/SplitLayout';

const propTypes = exact({
  payPeriod: PropTypes.object.isRequired,
  eligibleForClose: PropTypes.bool.isRequired,
  userTimesheets: PropTypes.array.isRequired,
  allMissingTicketNumbers: PropTypes.array.isRequired,
});

const OpenedPayPeriod = (props) => {
  const {
    userTimesheets, allMissingTicketNumbers, eligibleForClose, payPeriod,
  } = props;

  const renderLayout = () => {
    if (!eligibleForClose) {
      return (
        <SplitLayout
          leftSize={8}
          leftRender={() => { return <AwaitingApproval userTimesheets={userTimesheets} />; }}
          rightSize={4}
          rightRender={() => {
            return (
              <div style={{ marginTop: '-26px' }}>
                <h3>Missing Tickets</h3>
                <MissingTicketNumbers
                  allMissingTicketNumbers={allMissingTicketNumbers}
                />
              </div>
            );
          }}
        />
      );
    }

    if (eligibleForClose) {
      return (
        <div style={{ marginTop: '20px' }}>
          <h3>Missing Tickets</h3>
          <MissingTicketNumbers
            allMissingTicketNumbers={allMissingTicketNumbers}
          />
        </div>
      );
    }

    return null;
  };

  return (
    <div>
      {renderLayout()}
      <LockPayPeriod
        eligibleForClose={eligibleForClose}
        selectedPayPeriod={payPeriod}
      />
    </div>
  );
};

OpenedPayPeriod.propTypes = propTypes;

export default OpenedPayPeriod;
